// extracted by mini-css-extract-plugin
export default {"logo":"HeaderFile_logo__FzlG3","disabled":"HeaderFile_disabled__2YM06"};